export const cookiesHandler = {
    methods: {
        createCookie(oData) {
            var d = new Date();
            d.setTime(d.getTime() + 1 * 12 * 60 * 60 * 1000);
            document.cookie =
                oData.name + "=" +
                oData.value +
                "; expires=" + d.toUTCString() + ";domain="+
                window.location.hostname.toString();
        },
        getAllCookies() {
            var ListOfCookies = document.cookie.split(";");
            var c;
            var jar = [];
            for (var i = 0; i < ListOfCookies.length; i++) {
                c = ListOfCookies[i].split("=");
                var key = c[0].replace(" ", "");
                var value = c[1].replace(" ", "");
                jar.push({ key: key, value: value });
            }
            return jar;
        },
        getCookie(cName) {
            const name = cName + "=";
            const cDecoded = decodeURIComponent(document.cookie);
            const cArr = cDecoded.split("; ");
            let res;
            cArr.forEach((val) => {
                if (val.indexOf(name) === 0) res = val.substring(name.length);
            });
            return res;
            
        },
        deleteCookie(cName) {
            document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        },
        jarOfCookie() {
            var ListOfCookies = document.cookie.split(";");
            var c;
            var jar = [];
            for (var i = 0; i < ListOfCookies.length; i++) {
                c = ListOfCookies[i].split("=");
                var key = c[0].replace(" ", "");
                var value = c[1];
                jar.push({ key: key, value: value });
            }
            return jar;
        },
    },
}